import { Component, OnInit } from '@angular/core';
import { JsonDataService } from '../../services/json-data.service';

@Component({
  selector: 'app-apple-app-site-association',
  templateUrl: './apple-app-site-association.component.html'
})
export class AppleAppSiteAssociationComponent implements OnInit {
  jsonData: any;

  constructor(private readonly jsonDataService: JsonDataService) {}

  ngOnInit(): void {
    this.loadJsonData();
  }
  
  loadJsonData(): void {
    this.jsonDataService.getJsonData().subscribe((data) => {
      this.jsonData = data;
    });
  }
}
